import { BlockedState } from '~/gql/__generated__/types';
import { IStateProvinces } from '~/interfaces/states-provinces';

/**
 * Returns message with zipcode or empty string
 */
export const getBlockedZipCodeMessage = (
  stateName: string,
  zipCode: string,
  blockedStates: BlockedState[] | undefined,
) => {
  const filteredList = blockedStates?.filter((cityStateZipObj) => {
    return cityStateZipObj?.stateName === stateName;
  });
  return filteredList?.length && filteredList[0]
    ? (removeMarkup(
        filteredList[0].zipCodeMessage?.replace('{zipcode}', zipCode) ?? '',
      ) ?? '')
    : '';
};

/**
 * Returns message with state or empty string
 */
export function getBlockedStateMessage(
  stateName: string,
  blockedStates: BlockedState[],
): string {
  const filteredList = blockedStates?.filter((cityStateZipObj) => {
    return cityStateZipObj?.stateName === stateName;
  });
  return (filteredList?.length ? filteredList[0]?.message : '') ?? '';
}

export function getFilteredStatesFromBlockStates(
  stateProvinces?: IStateProvinces[],
  blockedStates?: BlockedState[],
): IStateProvinces[] | undefined {
  return stateProvinces?.filter((stateProvincesObj) => {
    return !blockedStates?.find(
      (blockedState) =>
        blockedState?.stateName === stateProvincesObj.StateId &&
        blockedState?.hideCheckoutState,
    );
  });
}

export const removeMarkup = (markup: string): string =>
  markup ? markup.replace(/<[^>]*>/g, '') : '';
